var r = Object.defineProperty;
var a = (t, e, s) => e in t ? r(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var l = (t, e, s) => a(t, typeof e != "symbol" ? e + "" : e, s);
class n {
  /**
   * @param accept 	string | undefined
   * 可能為
   * image/*
   * image/*, application/*
   * image/jpeg, application/pdf
   */
  constructor(e) {
    /**
     * 允許的 MIME 類型
     */
    l(this, "allowMimeTypes");
    /**
     * 驗證 MIME 類型是否符合允許的類型
     * @param mimeType - 要驗證的 MIME 類型
     * @returns 如果符合允許的類型返回 true，否則返回 false
     * @example
     * ```ts
     * const utils = new MediaLibraryUtils('image/*')
     * utils.validate('image/jpeg') // true
     * utils.validate('video/mp4') // false
     * ```
     */
    l(this, "validate", (e) => {
      var s;
      return (s = this.allowMimeTypes) != null && s.length ? this.allowMimeTypes.some((i) => i.endsWith("/*") ? e.startsWith(i.slice(0, -1)) : e === i) : !0;
    });
    if (!e) {
      this.allowMimeTypes = [];
      return;
    }
    const s = e.replace(/\s/g, "").split(",");
    this.allowMimeTypes = s;
  }
}
export {
  n as MimeTypeValidator
};
